import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { FeatureFlagView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminFeatureFlags } from "@/lib/query/core/invalidation";

export type CreateFeatureFlagInput = {
  key: string;
  nameEn: string;
  nameAr?: string;
  descriptionEn?: string;
  descriptionAr?: string;
  isActive: boolean;
  enableForAllStores: boolean;
  storeIds: string[];
};

export function useCreateFeatureFlagMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: CreateFeatureFlagInput) =>
      apiJsonClient<FeatureFlagView>(endpoints.admin.featureFlags, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
    onSuccess: async () => {
      await invalidateAdminFeatureFlags(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
